<template>
    <div>
        <div>
        <p>
            Selecteer een periode
        </p>
        <a-range-picker :placeholder="['Start dag', 'Eind dag']" v-model="date" @change="onChange" />
        <div v-if="revenueLoading"  class="w-100 d-flex justify-content-center align-items-center">
            <a-spin size="large" />
        </div>
        <div v-else>
            <div v-if="revenue">
                <p>
                    Omzet zonder BTW: {{revenue.revenue.without_vat.toFixed(2)}}
                </p>
                <p>
                    Omzet met BTW: {{revenue.revenue.with_vat.toFixed(2)}}
                </p>
                <p>
                    Aantal boekingen: {{revenue.reservations}}
                </p>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        user: {
            get: function () {
                return this.$store.state.user
            },
        },
    },
    data() {
        return {
            revenueLoading: false,
            revenue: null
        }
    },
    methods: {
        onChange(date, dateString) {
            console.log(dateString)
            this.revenueLoading = true;
            this.$axios.get('/bookkeeping/getRevenueByDateRange', {
                params: {
                from: dateString[0],
                to: dateString[1],
                },
                headers: {
                'Authorization': `Bearer ${this.user.user.token}`,
                } }).then(response => {
                this.revenue = response.data
                
                this.revenueLoading = false;
                
            })
            },
    }
}

</script>